import { createFileRoute } from "@tanstack/react-router";
import { FallbackEmpty } from "~/components/FallbackEmpty";
import { useHasPermission } from "~/hooks/useHasPermission";
import { ImpersonatePanel } from "~/routes/(restricted)/staff/-components/ImpersonatePanel";
import { StaffPermissionsPage } from "~/routes/(restricted)/staff/-components/StaffPermissionsPage";
import { StaffPermission } from "~/utils/permissions";

export const Route = createFileRoute("/(restricted)/staff/")({
  component: RouteComponent,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("staff");

    const title = i18n.t("staff:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function RouteComponent() {
  const canManageStaff = useHasPermission(StaffPermission.userManage);
  const canImpersonate = useHasPermission(StaffPermission.userImpersonate);

  if (!canManageStaff && !canImpersonate) return <FallbackEmpty />;

  return (
    <div className="bg-background flex w-full max-w-206 flex-col gap-4 py-10">
      {canImpersonate ? <ImpersonatePanel /> : null}
      {canManageStaff ? <StaffPermissionsPage /> : null}
    </div>
  );
}
